package org.hs_soft.runmynesto.di.options

import org.hs_soft.runmynesto.data.api_datasource.options.cash_flow.GetAppConfigRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_flow.UpdateAppConfigRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.ApaleoPropertiesRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.AydenStoresRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.CreateCashRegisterRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.CreateNewDepartmentRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.CreateNewRegionRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.CreateNewShopRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.GetCashRegisterConfigRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.ListDeviceRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.TSELocationsRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config.UpdateCashRegisterConfigRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.export.ApaleoPaymentMethodsRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.export.ApaleoSubAccountRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.export.CashRegisterGlobalRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.export.OptionCreditCardRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.export.UpdateCashRegisterGlobalRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.menu_card_import.GetMenuCardRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.menu_card_import.UpsertProductsRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.operation.OptionsDataRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.operation.UpdateOptionRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.price_category.UpdatePriceCategoryRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.printer_location.UpdatePrinterLocationRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.CreateFloorRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.CreateFurnitureRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.CreateRoomRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.DeleteFloorRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.DeleteFurnitureRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.DeleteRoomRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.RestaurantProjectsRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.UpdateFloorRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.UpdateFurnitureRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.UpdateRestaurantProjectRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager.UpdateRoomRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.sale_group.AddNewSaleGroupRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.sale_group.SingleSaleGroupRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.sale_group.UpdateSaleGroupRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.virtual_card.GetVirtualCardInfoRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.virtual_card.UpdateVirtualCardInfoRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_click_collect.UpdateProductPropertiesRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.template.AddCategoryRepositoryImpl
import org.hs_soft.runmynesto.data.local_datasource.local_storage.options.SaveLanguageRepositoryImpl
import org.hs_soft.runmynesto.domain.repository.network_datasource.AddCategoryRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_flow.GetAppConfigRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_flow.UpdateAppConfigRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.ApaleoPropertiesRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.AydenStoresRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateCashRegisterRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewDepartmentReopisotry
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewRegionReopisotry
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewShopRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.GetCashRegisterConfigRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.TSELocationsRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.UpdateCashRegisterConfigRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.ApaeloPaymentMethodsRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.ApaleoSubAccountRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.CashReigsterGloabalRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.OptionCreditCardRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.UpdateCashReigsterGloabalRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.menu_card_import.GetMenuCardRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.menu_card_import.UpsertProductsRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.operation.OptionDataRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.operation.SaveLanguageRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.operation.UpdateOptionRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.printer_location.UpdatePrinterLocationRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.CreateFloorRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.CreateFurnitureRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.CreateRoomRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.DeleteFloorRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.DeleteFurnitureRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.DeleteRoomRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.RestaurantProjectsRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.UpdateFloorRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.UpdateFurnitureRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.UpdateRestaurantProjectRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.UpdateRoomRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.sales_group.AddNewSaleGroupRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.sales_group.SingleSaleGroupRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.sales_group.UpdateSaleGroupRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.virtual_card.GetVirtualCardInfoRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.virtual_card.UpdateVirtualCardInfoRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_click_collect.UpdateProductPropertiesRepository
import org.koin.dsl.module
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.ListDeviceRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.price_category.UpdatePricesCategoryRepository

val optionRepositoryModule= module {

    single<UpdatePricesCategoryRepository>{
        UpdatePriceCategoryRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<AydenStoresRepository>{
        AydenStoresRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<ApaleoPropertiesRepository>{
        ApaleoPropertiesRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<CreateCashRegisterRepository>{
        CreateCashRegisterRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<CreateNewShopRepository>{
        CreateNewShopRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<CreateNewRegionReopisotry>{
        CreateNewRegionRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }
    single<CreateNewDepartmentReopisotry>{
        CreateNewDepartmentRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }
    single<UpdatePrinterLocationRepository> {
        UpdatePrinterLocationRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }

    single<OptionDataRepository> {
        OptionsDataRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }

    single<AddNewSaleGroupRepository> {
        AddNewSaleGroupRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }


    single<SingleSaleGroupRepository> {
        SingleSaleGroupRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }
    single<UpdateSaleGroupRepository>{
        UpdateSaleGroupRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }


    single<UpdateOptionRepository> {
        UpdateOptionRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }

    single<UpdateVirtualCardInfoRepository>{
        UpdateVirtualCardInfoRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }

    single<GetAppConfigRepository>{
        GetAppConfigRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }
    single<UpdateAppConfigRepository>{
        UpdateAppConfigRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }
    single<GetCashRegisterConfigRepository>{
        GetCashRegisterConfigRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }
    single<UpdateCashRegisterConfigRepository>{
        UpdateCashRegisterConfigRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }
    single<GetVirtualCardInfoRepository>{
        GetVirtualCardInfoRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }

    single<GetMenuCardRepository>{
        GetMenuCardRepositoryImpl(
            get()
        )
    }

    single<RestaurantProjectsRepository> {
        RestaurantProjectsRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<CreateFurnitureRepository> {
        CreateFurnitureRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }
    single<UpdateFurnitureRepository>{
        UpdateFurnitureRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<CreateFloorRepository>{
        CreateFloorRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<UpdateFloorRepository>{
        UpdateFloorRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }
    single<DeleteFloorRepository>{
        DeleteFloorRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<DeleteRoomRepository>{
        DeleteRoomRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<UpsertProductsRepository> {
        UpsertProductsRepositoryImpl(
            apiClient =get(),
            requestManager = get(),
        )
    }

    single<AddCategoryRepository> {
        AddCategoryRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }

    single<UpdateProductPropertiesRepository> {
        UpdateProductPropertiesRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<CreateRoomRepository> {
        CreateRoomRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }


    single<UpdateRoomRepository> {
        UpdateRoomRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<UpdateRestaurantProjectRepository> {
        UpdateRestaurantProjectRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<DeleteFurnitureRepository> {
        DeleteFurnitureRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<SaveLanguageRepository> {
        SaveLanguageRepositoryImpl()
    }

    single<ApaeloPaymentMethodsRepository> {
        ApaleoPaymentMethodsRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<OptionCreditCardRepository> {
        OptionCreditCardRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<CashReigsterGloabalRepository> {
        CashRegisterGlobalRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<UpdateCashReigsterGloabalRepository> {
        UpdateCashRegisterGlobalRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<ApaleoSubAccountRepository> {
        ApaleoSubAccountRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<TSELocationsRepository> {
        TSELocationsRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }

    single<ListDeviceRepository> {
        ListDeviceRepositoryImpl(get(), get())
    }

}